import { BetDetails, ParlaySelection } from "../models/MyBetModel.tsx";
import { isLiveBet } from "./functions.tsx";
import { resolveParlayQueeAction } from "./parlayMarketConflicts.ts";

export function toParlaySelection(bet: BetDetails): ParlaySelection | null {
    if (!bet.fixture_id || !bet.odd) return null;
    if (bet.betType === "Contest") return null;
    if (isLiveBet(bet)) return null;

    return {
        id_selection: bet.id_selection,
        gameId: bet.gameId,
        league: bet.league,
        sport: bet.sport,
        marketName: bet.marketName,
        gameDate: bet.gameDate,
        teamId: bet.teamId,
        betName: bet.betName,
        fixture_id: bet.fixture_id,
        betStatus: bet.betStatus || "pending",
        odd: bet.odd,
        odds: bet.odds,
        opposingTeam: bet.opposingTeam,
        logo: bet.logo,
        pitchers: bet.pitchers,
        marketType: bet.marketType,
        selectionType: bet.selectionType,
        ticket: bet.ticket || "",
        grader: bet.grader,
        lastUpdateBySystem: bet.lastUpdateBySystem,
        oddLive: bet.oddLive,
    };
}

export function toStraightBet(bet: ParlaySelection): BetDetails {
    return {
        ...bet,
        bet: 0,
        reward: 0,
        betType: "Straight",
        betStatus: bet.betStatus || "pending",
        betDate: bet.gameDate,
    };
}

export type ConvertStraightsResult =
    | { ok: true; selections: ParlaySelection[] }
    | { ok: false; message: string };

export function convertStraightsToParlay(bets: BetDetails[]): ConvertStraightsResult {
    if (bets.length < 2) {
        return {
            ok: false,
            message: "A parlay needs at least 2 selections.",
        };
    }

    const next: ParlaySelection[] = [];

    for (const bet of bets) {
        if (bet.betType === "Contest") {
            return {
                ok: false,
                message: "These bets cannot be moved to Parlay because they are not valid for a parlay.",
            };
        }

        if (isLiveBet(bet)) {
            return {
                ok: false,
                message: "These bets cannot be moved to Parlay because they are not valid for a parlay.",
            };
        }

        const selection = toParlaySelection(bet);
        if (!selection) {
            return {
                ok: false,
                message: "These bets cannot be moved to Parlay because they are not valid for a parlay.",
            };
        }

        const decision = resolveParlayQueeAction(next, selection);
        if (decision.action !== "add") {
            return {
                ok: false,
                message: "These bets cannot be moved to Parlay because they are not valid together.",
            };
        }

        next.push(selection);
    }

    return { ok: true, selections: next };
}

export function convertParlaysToStraight(bets: ParlaySelection[], existingStraight: BetDetails[] = []): BetDetails[] {
    return bets.map((bet) => {
        const converted = toStraightBet(bet);
        const existing = existingStraight.find((item) => item.id_selection === converted.id_selection);
        if (!existing) return converted;
        return { ...converted, bet: existing.bet, reward: existing.reward };
    });
}

